import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyA8tqeFWlHB_9Z3ShUagSivOe8FENfcIuQ',
  authDomain: 'monorepo-ci-1a4e3.firebaseapp.com',
  projectId: 'monorepo-ci-1a4e3',
  storageBucket: 'monorepo-ci-1a4e3.firebasestorage.app',
  messagingSenderId: '140483372336',
  appId: '1:140483372336:web:c72d932112dc99559b94f5',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
